import React from 'react';
import {
    ItemButton,
    ItemWrapper,
    VerticalMoveIconWrapper
} from './SportGeneral.style';

class SportItemGeneral extends React.Component {
    render() {
        const { name, isDragged } = this.props;

        return (
            <ItemWrapper>
                <span>{name}</span>
                <ItemButton
                    isDragged = { isDragged }
                    data-movable-handle
                    tabIndex={-1}
                >
                    <VerticalMoveIconWrapper />
                </ItemButton>
            </ItemWrapper>
        );
    }
}

export default SportItemGeneral;
